import React from "react";
import { isEmpty } from "lodash";
// components
// types
import { TFooterComponent } from '../type';
import { Link } from "react-router-dom";
import Logo from "components/Logo";
import CompanyIntroduction from "./CompanyIntroduction";
import { ELayoutType } from "cms/enums/ELayoutType";
import RMDRImage from "components/RMDRImage";


function MiddleBarLoader () {

    return (
        <></>
    )

}

const MiddleBar = ( props:TFooterComponent ) => {
    console.log("MiddleBar.rendered", props);

    const parentItem = props.payload?.find((item) => item.layouts?.filter((litem) => litem.layoutName === props.layoutName).length > 0);

    if ( parentItem && !isEmpty(parentItem) ) {

        const childItems = props.payload?.filter((item) => item.parentId === parentItem.id);

        console.log("childItems: ", props, childItems);

        return (
            <>
                <div className="site-footer-three__shape-1 float-bob-x">
                    <RMDRImage
                        title="TMD Grup Middlebar"
                        alt="TMD Grup Middlebar"
                        src="/assets/images/shapes/site-footer-three-shape-1.webp"
                        width={1074}
                        height={560}
                        className="!tw-max-w-none"
                    />
                </div>
                <div className="site-footer-three__top">
                    <div className="container">
                        <div className="site-footer-three__top-inner">
                            <div className="row">

                                {
                                    childItems?.map((item) => {

                                        const layout = item.layouts.find((item) => item.layoutType === ELayoutType.MAIN_PAGE);

                                        if ( layout?.layoutName === "MNPG_008" ) {
                                            return (
                                                <CompanyIntroduction
                                                    payload={props.payload}
                                                    webApplicationLanguageISOCode={props.webApplicationLanguageISOCode}
                                                    parentPayload={item}
                                                />
                                            )
                                        }

                                        return null;
                                    })
                                }
                                
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    return <MiddleBarLoader />;

}

export default MiddleBar;
